// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import AxiosPlugin from './libs/AxiosPlugin'
import Request from './utils/request'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import store from './store/'
import './assets/iconfont/font.css'
import { isLoggedIn } from '@/utils/storage';

Vue.use(Request)
Vue.use(AxiosPlugin)
Vue.use(ElementUI);
Vue.config.productionTip = false;


router.beforeEach(async (to, from, next) => {
  try {
    // 获取路由参数
    const stationId = to.params.stationId
    const projectId = to.params.projectId ? to.params.projectId.replace('p', '') : null
    
    // 从 store 中获取网站标题（传递projectId以获取项目名称）
    const companyInfo = await store.dispatch('company/fetchCompanyInfo', projectId)
    const siteTitle = companyInfo.title || '报名系统'
    
    // 设置页面标题
    if (to.meta && to.meta.title) {
      document.title = `${to.meta.title} - ${siteTitle}`
    } else {
      document.title = siteTitle
    }
    
    if (to.path.includes('/user-center') && !isLoggedIn()) {
      // 保持projectId参数（projectId已包含p前缀，如p125）
      const loginPath = to.params.projectId ? `/${stationId}/login/${to.params.projectId}` : `/${stationId}/login`
      next(loginPath)
    } else {
      next()
    }
  } catch (error) {
    next()
  }
})

/* eslint-disable no-new */
const messages = {
  'en-US': {
    header: {
      title: 'FormMaking',
      document: 'Docs',
      pricing: 'Pricing',
      advanced: 'Advanced',
    }
  },
  'zh-CN': {
    header: {
      title: '表单设计器',
      document: '使用文档',
      pricing: '商业授权',
      advanced: '高级版本',
    }
  }
}

const i18n = new VueI18n({
  messages: {
    'en-US': {
      ...enLocale, ...messages['en-US']
    },
    'zh-CN': {
      ...zhLocale, ...messages['zh-CN']
    }
  }
})

Vue.use(ElementUI, { 
  size: 'small',
  i18n: (key, value) => i18n.t(key, value)
})
import FormMaking from 'form-making'
import 'form-making/dist/FormMaking.css'
Vue.use(FormMaking, {
  i18n
})
new Vue({
  i18n,
  store,
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js